module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"BranchesMap":{"branchTypeFilter":{"heading":"Typ","sellingUs":"Prodávají nás","workingWithUs":"Pracují s námi"},"heading":"Prodejci, partneři","regionFilter":{"deselect":"Všechny kraje","label":"Kraj"}}}}')
  delete Component.options._Ctor
}
